// extracted by mini-css-extract-plugin
export var actionIcon = "_sf-0";